import { Routes, Route } from 'react-router-dom';
import React, { useEffect } from "react";
import Home from './Home.js';
import LoadingPage from './LoadingPage.js';
import { initGA } from "./Analytics";
import PageTracker from "./PageTracker";
import ContactUs from './ContactUs.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import config from "./config.js";

function App() {
  useEffect(() => {
    initGA(config.analytics.ga_id); // replace with your GA4 ID
  }, []);
  return (
    <>
      <PageTracker />
      <Routes>
        <Route path="/" element={<LoadingPage />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

export default App;
